// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors":"edfb09","app":"e81950","components_Customers_Bookings_Index_vue":"6cb786","components_Vendors_Bookings_Index_vue":"9e6415"}[chunkId] + ".bundle.js";
};